<template>
    <div class="modal-subprofiles modal">
        <div class="wrapper">
            <IconClose class="close" @click="close"></IconClose>

            <div class="modal-subprofiles__wrapper">
                <p class="modal-subprofiles__title" v-if="isFavorite">{{ title.remove }}</p>
                <p class="modal-subprofiles__title" v-else>{{ title.add }}</p>

                <div class="modal-subprofiles__list" v-if="subProfilesList">
                    <carousel :settings="settings" :class="{'single': subProfilesList.length === 1 }">
                        <slide v-for="item in subProfilesList" :key="item._id">
                            <div 
                                class="modal-subprofiles__item"   
                                :class="{'selected': selected === item._id}"   
                                @click="selectSubprofile(item._id)"
                                :key="item._id" 
                            >
                                <img class="modal-subprofiles__avatar" :src="getAvatar(item.avatar && item.avatar.url)" >
                                <span class="modal-subprofiles__name">{{ item.name }}</span>
                            </div>
                        </slide>

                        <template #addons="{ slidesCount }">
                            <navigation v-if="slidesCount > 2" />
                        </template>
                    </carousel>
                </div>

                <button class="btn" @click.prevent="setSubprofile"><span>Akceptuj</span></button>
            </div>
        </div>
    </div>
</template>

<script>
import { Carousel, Slide, Navigation } from 'vue3-carousel';
import IconClose from "../elements/icons/IconClose.vue";
import { parseImageUrl } from '../../mixins/useParseImage';
import { useToast } from "vue-toastification";
import 'vue3-carousel/dist/carousel.css';
const toast = useToast()

export default {
    name: "ModalSelectSubProfile",
    mixins: [parseImageUrl],
    props: {
        subProfilesList: {
            type: Array,
            required: true,
        },
        isFavorite: {
            type: Boolean
        }
    },
    data() {
        return {
            showModal: false,
            selected: '',
            settings: {
                itemsToShow: 2,
                itemsToScroll: 2,
                snapAlign: 'start'
            },
            title: {
                add: 'Dodaj do ulubionych',
                remove: 'Usuń z ulubionych'
            }
        };
    },
    components: {
        IconClose,
        Carousel,
        Slide,
        Navigation        
    },
    methods: {
        selectSubprofile(id) {
            this.selected = id;
        },
        getAvatar(url) {
            return parseImageUrl(url, 152,152);
        },
        close() {
            this.$emit("toggleModalFavorites");
        },
        setSubprofile() {
            if(this.selected) {
                this.$emit("selectSubprofile", this.selected);
                this.$emit("toggleModalFavorites");
            } else {
                toast.error("Wybierz profil dziecka");
            }
        }
    }
};
</script>
